import { environment } from '@/environments/environment'

export default [
  { name: 'getCustomization', url: `${environment.torontoApiUrl}/public-shipper-style-customization`, method: 'get' },
  { name: 'sendTicketMessage', url:  `${environment.torontoApiUrl}/receive-complaint-data`, method: 'post'}
]
